import { useCallback } from 'react';
import BigNumber from 'bignumber.js';

import ButtonLink from '#/components/shared/ButtonLink';

import { logException } from '#/features/logging/logging';
import useCollectFunds from '#/features/withdraw/useCollectFunds';
import { publishNotification } from '#/features/notifications/topic';

interface Props {
  readonly label: string;
  readonly amountRaw: BigNumber;
  readonly amountFormatted: string;
  readonly asset: string;
}

export default function CollectFundsAction(props: Props) {
  const [collectFunds, { isBusy }] = useCollectFunds();

  const handleClick = useCallback(() => {
    (async () => {
      const result = await collectFunds(props.amountRaw, props.asset);

      if (!result.ok) {
        publishNotification({
          kind: 'withdraw-to-wallet-request-failed',
          props: { message: result.reason },
        });
        return;
      }

      publishNotification({
        kind: 'withdraw-to-wallet-request-sent',
        props: { amount: props.amountFormatted },
      });
    })().catch((err) => {
      publishNotification({
        kind: 'withdraw-unexpected-error',
        props: {},
      });

      const message = 'Unexpected error in withdraw to L1 action';
      logException(new Error(message, { cause: err }));
    });
  }, [collectFunds, props]);

  return (
    <ButtonLink disabled={isBusy} onClick={handleClick}>
      {props.label}
    </ButtonLink>
  );
}
